<div class="container-fluid">
  <form (ngSubmit)="onSubmit()" [formGroup]="Newjoin">
    <div class="py-2"></div>
    <div class="row">
      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="text"
            class="form-control text-capitalize"
            formControlName="newJoinId"
            value="{{ currentNewJoinId }}"
            readonly
          />
          <label>Employee ID <span class="text-danger">*</span></label>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <select
            class="form-control"
            id="epid"
            formControlName="employeeType"
            (change)="onEmployee($event)"
          >
            <option value="" disabled selected hidden>
              Select Employee Type
            </option>
            <option value="Full Time">Full Time</option>
            <option value="Part Time">Part Time</option>
          </select>
          <label class="form-label"
            >Employment Type <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.employeeType" class="text-danger">{{
            NewJoinErrors.employeeType
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <select formControlName="location" class="form-control">
            <option value="" disabled selected hidden>Select Any One</option>
            <option value="Work From Home">Work From Home</option>
            <option value="Onsite">Onsite</option>
          </select>
          <label>Location <span class="text-danger">*</span> </label>
          <span *ngIf="NewJoinErrors.location" class="text-danger">{{
            NewJoinErrors.location
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="date"
            formControlName="employeeJoiningDate"
            class="form-control text-capitalize"
            [max]="currentDate"
          />
          <span
            *ngIf="NewJoinErrors.employeeJoiningDate"
            class="text-danger"
            >{{ NewJoinErrors.employeeJoiningDate }}</span
          >
          <label
            >Employee Joining Date <span class="text-danger">*</span></label
          >
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="text"
            class="form-control text-capitalize"
            formControlName="employeeName"
            id="employeeName"
            placeholder="Name"
          />
          <label class="form-label"
            >Employee Name <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.employeeName" class="text-danger">{{
            NewJoinErrors.employeeName
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="text"
            class="form-control text-capitalize"
            formControlName="employeeFatherName"
            placeholder="Fathers Name"
          />
          <label>Father's Name <span class="text-danger">*</span></label>
          <span
            *ngIf="NewJoinErrors.employeeFatherName"
            class="text-danger"
            >{{ NewJoinErrors.employeeFatherName }}</span
          >
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div
          class="form-group"
          style="border-radius: 5px !important; border: 1px solid"
        >
          <label class="ms-2">Gender <span class="text-danger">*</span></label>
          <br />
          <div class="form-check form-check-inline ms-2">
            <input
              class="form-check-input"
              type="radio"
              formControlName="gender"
              value="Male"
            />
            <label class="form-check-label">Male</label>
          </div>
          <div class="form-check form-check-inline ms-2">
            <input
              class="form-check-input"
              type="radio"
              formControlName="gender"
              value="Female"
            />
            <label class="form-check-label">Female</label>
          </div>
        </div>
        <span *ngIf="NewJoinErrors.gender" class="text-danger">{{
          NewJoinErrors.gender
        }}</span>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="date"
            formControlName="dateOfBirth"
            class="form-control text-capitalize"
            (change)="dateOfBirth($event)"
            [max]="currentDate"
          />
          <label class="form-label"
            >Date of Birth <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.dateOfBirth" class="text-danger">{{
            NewJoinErrors.dateOfBirth
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="text"
            formControlName="age"
            class="form-control text-capitalize"
            placeholder="Age"
            value="{{ age }}"
            readonly
          />
          <span *ngIf="NewJoinErrors.age" class="text-danger">{{
            NewJoinErrors.age
          }}</span>
          <label>Age <span class="text-danger">*</span></label>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <select
            class="form-select"
            formControlName="designation"
            placeholder="Designation"
            (change)="onSelectDesignation($event)"
          >
            <option value="" disabled selected hidden> Select Any Designation </option>
            <option *ngFor="let designation of this.designationDetails" [value]="designation?.designationName">{{designation?.designationName}}</option>
          
          </select>
          <label>Designation <span class="text-danger">*</span></label>
          <span *ngIf="NewJoinErrors.designation" class="text-danger">{{
            NewJoinErrors.designation
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <textarea
            class="form-control"
            formControlName="qualification"
            placeholder="Designation"
          ></textarea>
          <label class="form-label"
            >Qualification <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.qualification" class="text-danger">{{
            NewJoinErrors.qualification
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <textarea
            class="form-control"
            formControlName="address"
            placeholder="Address"
          ></textarea>
          <label class="form-label"
            >Address <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.address" class="text-danger">{{
            NewJoinErrors.address
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="text"
            class="form-control text-capitalize"
            formControlName="employeeLocation"
            placeholder="Location"
          />
          <label>Location <span class="text-danger">*</span></label>
          <span *ngIf="NewJoinErrors.employeeLocation" class="text-danger">{{
            NewJoinErrors.employeeLocation
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <select
            class="form-select text-capitalize"
            formControlName="bloodGroup"
            placeholder="Bloodgroup"
          >
            <option value="" disabled selected>Select Blood Group</option>
            <option *ngFor="let group of bloodGroups" [value]="group">
              {{ group }}
            </option>
          </select>
          <label class="form-label"
            >Select a Blood Group <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.bloodGroup" class="text-danger">{{
            NewJoinErrors.bloodGroup
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2" *ngIf="this.isLoginUserDetails">
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            formControlName="userName"
            placeholder="Username"
          />
          <label>Username <span class="text-danger">*</span></label>
          <span *ngIf="NewJoinErrors.userName" class="text-danger">{{
            NewJoinErrors.userName
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2" *ngIf="this.isLoginUserDetails">
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            formControlName="password"
            placeholder="Password"
          />
          <label>Password <span class="text-danger" style="font-size: small;">(Provide a password if required)</span></label>
          <span *ngIf="NewJoinErrors.password" class="text-danger">{{
            NewJoinErrors.password
          }}</span>
        </div>
      </div>
    </div>

    <hr *ngIf="bankDisable" style="border: 3px solid" />
    <div class="row" *ngIf="bankDisable">
      <div class="row col-12 mb-1 mt-1">
        <div class="text-center">
          <h5>Bank Account Details</h5>
        </div>
        <br />
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="text"
            formControlName="aadharNo"
            class="form-control text-capitalize"
            placeholder="Aadhar Number"
            (keypress)="numberOnly($event)"
            maxlength="12"
          />
          <label class="form-label"
            >Aadhar Number <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.aadharNo" class="text-danger">{{
            NewJoinErrors.aadharNo
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <select
            name="bankname"
            formControlName="bankName"
            class="form-control"
          >
            <option value="" select disabled>Select a Bank Name</option>
            <option *ngFor="let bank of bankNames" [value]="bank">
              {{ bank }}
            </option>
          </select>
          <label>Bank Name <span class="text-danger">*</span></label>
          <span *ngIf="NewJoinErrors.bankName" class="text-danger">{{
            NewJoinErrors.bankName
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="text"
            formControlName="branchName"
            class="form-control text-capitalize"
            placeholder="Branch Name"
          />
          <label>Branch Name <span class="text-danger">*</span></label>
          <span *ngIf="NewJoinErrors.branchName" class="text-danger">{{
            NewJoinErrors.branchName
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="text"
            formControlName="bankIfscCode"
            class="form-control text-capitalize"
            placeholder="IFSC Code"
          />
          <label class="form-label"
            >Bank IFSC Code <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.bankIfscCode" class="text-danger">{{
            NewJoinErrors.bankIfscCode
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="text"
            class="form-control text-capitalize"
            formControlName="nameAsInPassbook"
            placeholder="Name as a passbook"
          />
          <label class="form-label"
            >Name as a passbook <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.nameAsInPassbook" class="text-danger">{{
            NewJoinErrors.nameAsInPassbook
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="tel"
            formControlName="accountNo"
            class="form-control text-capitalize"
            placeholder="Account Number"
            min="0"
            (keypress)="numberOnly($event)"
          />
          <label>Account Number <span class="text-danger">*</span></label>
          <span *ngIf="NewJoinErrors.accountNo" class="text-danger">{{
            NewJoinErrors.accountNo
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="text"
            formControlName="employeeContactNo"
            class="form-control text-capitalize"
            placeholder="Employee Contact"
            (keypress)="numberOnly($event)"
            maxlength="10"
          />
          <label class="form-label"
            >Employee contact <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.employeeContactNo" class="text-danger">{{
            NewJoinErrors.employeeContactNo
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="text"
            class="form-control text-capitalize"
            formControlName="emergencyContactNo"
            placeholder="Emergency Number"
            (keypress)="numberOnly($event)"
            maxlength="10"
          />
          <label>Emergency Number <span class="text-danger">*</span></label>
          <span
            *ngIf="NewJoinErrors.emergencyContactNo"
            class="text-danger"
            >{{ NewJoinErrors.emergencyContactNo }}</span
          >
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <select
            class="form-control"
            formControlName="workingStatus"
            (change)="onSelectStatus($event)"
          >
            <option value="" selected disabled>Select a Work Status</option>
            <option
              *ngFor="let name of this.employeeStatusList"
              [value]="name.label"
            >
              {{ name.label }}
            </option>
          </select>
          <label class="form-label"
            >Working Status <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.workingStatus" class="text-danger">{{
            NewJoinErrors.workingStatus
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <select
            class="form-select"
            formControlName="salaryType"
            placeholder="Salary Type"
          >
            <option value="" selected disabled>Select a Salary Type</option>
            <option value="Fixed">Fixed</option>
            <option value="Variables">Variables</option>
            <option value="PerIndex">PerIndex</option>
          </select>
          <label class="form-label"
            >Salary Type <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.salaryType" class="text-danger">{{
            NewJoinErrors.salaryType
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <select class="form-control" formControlName="minimumLeavePolicy">
            <option value="" selected disabled>Select a Leave Policy</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          <label class="form-label">Min.Leave Policy</label>
          <span *ngIf="NewJoinErrors.minimumLeavePolicy" class="text-danger">{{
            NewJoinErrors.minimumLeavePolicy
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="number"
            class="form-control text-capitalize"
            formControlName="allowedLeaveDays"
            placeholder="Allowed Leave Days"
            min="0"
            (keypress)="numberOnly($event)"
          />
          <label class="form-label"
            >Allowed Leave Days <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.allowedLeaveDays" class="text-danger">{{
            NewJoinErrors.allowedLeaveDays
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12 mb-2">
        <div class="form-floating">
          <input
            type="number"
            class="form-control"
            formControlName="salaryValueFixed"
            placeholder="Salary Value Fixed"
          />
          <label class="form-label"
            >Salary Value Fixed <span class="text-danger">*</span></label
          >
          <span *ngIf="NewJoinErrors.salaryValueFixed" class="text-danger">{{
            NewJoinErrors.salaryValueFixed
          }}</span>
        </div>
      </div>

      <div class="col-md-4 col-lg-3 col-12">
        <div class="form-floating">
          <input
            type="number"
            class="form-control"
            formControlName="otherAllowance"
            placeholder="Enter the other allowance"
            min="0"
            (keypress)="numberOnly($event)"
          />
          <label class="form-label">Other Allowance</label>
        </div>
      </div>

      <div
        class="col-md-4 col-lg-3 col-12 mb-2"
        *ngIf="onShowRelivingDate == true"
      >
        <div class="form-floating">
          <input
            type="date"
            class="form-control text-capitalize"
            formControlName="relieveDate"
            placeholder="Reliving Date"
          />
          <label class="form-label">Reliving Date</label>
          <span *ngIf="NewJoinErrors.relieveDate" class="text-danger">{{
            NewJoinErrors.relieveDate
          }}</span>
        </div>
      </div>
    </div>

    <hr style="border: 3px solid">
    <h4 class="text-center">Document Upload</h4>

    <div class="row d-flex justify-content-center">
      <div class="card col-lg-10">
        <div class="ms-3 mt-3 mb-3">
          <!-- Loop through document types -->
          <ng-container *ngFor="let doc of documentTypes">
            <div class="row align-items-center mb-3">
              <!-- File Upload Input -->
              <div class="col-md-4 col-sm-12">
                <div class="form-floating">
                  <input
                    type="file"
                    class="form-control"
                    [id]="doc.id"
                    accept="image/png, image/jpeg, image/jpg, image/bmp, image/webp"
                     capture="environment"
                    (change)="fileUpload($event, doc.type)"
                  />
                  <label [for]="doc.id">{{ doc.label }}</label>
                </div>
              </div>

              <!-- Preview Image -->
             <div class="col-md-2 col-sm-12" *ngIf="getImageByType(doc.type)">
  <img
    [src]="getImageByType(doc.type)?.temporaryImagePath"
    alt="Preview"
    class="img-thumbnail"
    style="max-height: 100px; width: auto"
  />
</div>


              <!-- Remove Button -->
              <div class="col-md-2 col-sm-12" *ngIf="getImageByType(doc.type)">
                <button type="button"
                  class="btn btn-danger btn-sm"
                  (click)="removeImage(doc.type)"
                >
                  Remove
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="card-body text-center mt-2 mb-3">
      <button *ngIf="saveButton" type="submit" class="btn btn-success ml-4">
        <span style="margin: center">{{
          this.isUpdate == true ? "Update" : "Save"
        }}</span>
      </button>
      <button
        type="button"
        class="btn btn-primary ml-5"
        *ngIf="nextButton"
        (click)="Navigate()"
      >
        <span style="margin: center">Next</span>
      </button>
    </div>
  </form>
</div>
